/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import './style.scss';

import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import { deleteProposal, getAll as getAllProposals } from 'apis/proposals';

import Confirm from 'features/Proposal/components/Confirm';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tag } from 'primereact/tag';

import { mapError } from 'utils/func';
import ViewRequests from 'features/ProjectProposal/components/ViewRequests';
import ViewHistoryProposal from 'features/Proposal/components/ViewHistoryProposal';

function ProposalViewList() {
  // #region Data
  const { t } = useTranslation();

  const [viewHistoryVisible, setViewHistoryVisible] = useState(false);
  const [projectHistory, setProjectHistory] = useState([]);

  const { data, isLoading, isError, error, refetch } = useQuery('proposals', getAllProposals);
  const proposals = useMemo(() => data?.data ?? [], [data?.data]);

  const statuses = t('proposal.viewList.statuses', { returnObjects: true });
  // const user = JSON.parse(localStorage.getItem('user'));
  const dialogConfirmDeleteRef = useRef();
  const dialogViewRequestsRef = useRef();

  const typeProposalOptions = [
    { name: t('proposal.typeProposal.project'), value: 'project' },
    { name: t('proposal.typeProposal.topic'), value: 'topic' },
    { name: t('proposal.typeProposal.productionProject'), value: 'production_project' },
  ];

  const { mutate: mutateDelete } = useMutation(deleteProposal);
  // #endregion

  // #region Render
  const formatActions = (value) => (
    <div className="flex flex-wrap justify-content-center gap-1">
      <div className="flex align-items-center flex-wrap bg-blue-500 border-round-lg">
        <Link to={`/proposal/view/${value.id}`}>
          <Button
            // eslint-disable-next-line react/jsx-indent-props
            icon="pi pi-eye"
            severity="info"
            tooltip={t('proposal.view.label')}
            tooltipOptions={{ position: 'left', at: 'left top' }}
            style={{ width: '42px', height: '42px' }}
          />
        </Link>
      </div>

      <Button
        icon="pi pi-history"
        tooltip={t('proposal.history.tooltip')}
        tooltipOptions={{ position: 'left' }}
        onClick={() => {
          setProjectHistory(value?.proposalLogs ?? []);
          setViewHistoryVisible(true);
        }}
      />

      {value.status === 'new' && (
        <div className="flex align-items-center flex-wrap border-round-lg">
          <Link to={`/proposal/edit/${value.id}`}>
            <Button
              icon="pi pi-pencil"
              severity="warning"
              tooltip={t('proposal.edit.label')}
              tooltipOptions={{ position: 'left', at: 'left top' }}
              style={{ width: '42px', height: '42px' }}
            />
          </Link>
        </div>
      )}

      {value.status === 'new' && (
        <div className="flex align-items-center flex-wrap border-round-lg">
          <Button
            icon="pi pi-trash"
            severity="danger"
            tooltip={t('proposal.delete.label')}
            tooltipOptions={{ position: 'left', at: 'left top' }}
            onClick={() => {
              dialogConfirmDeleteRef.current.open({
                mode: 'delete',
                mutate: mutateDelete,
                value,
              });
            }}
            style={{ width: '42px', height: '42px' }}
          />
        </div>
      )}
    </div>
  );

  const formatStatus = (value) => {
    const statusColorMapping = {
      new: 'success',
      submitted: 'info',
      rejected: 'danger',
    };

    return (
      <Tag
        style={{ width: '5rem' }}
        severity={statusColorMapping[value.status]}
        value={statuses[value.status]}
        rounded
      />
    );
  };

  const formatProposalType = (value) =>
    typeProposalOptions.map(
      (type) =>
        type.value === value.type && (
          <p key={type.value} className="m-0">
            {type.name}
          </p>
        )
    );

  const formatResearchField = (value) =>
    value.proposalResearchFields.map((researchField) => (
      <p key={researchField.researchField.code} className="m-0 ">
        {t(`researchFields.${researchField.researchField.code}`)}
      </p>
    ));
  // #endregion Render

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          {isError && <h3 className="text-red-600">{mapError(t, error)}</h3>}
          {/* <div className="flex justify-content-between align-items-end mb-4 pb-2">
            <h5 className="p-0 m-0">{t('proposal.viewList.label')}</h5>
            <Link to="/proposal/create">
              <Button
                className="bg-cyan-600 border-cyan-600"
                label={t('proposal.viewList.createProposal')}
                icon="pi pi-plus"
              />
            </Link>
          </div> */}

          <DataTable
            value={proposals}
            className="p-datatable-gridlines header-table"
            showGridlines
            dataKey="id"
            filterDisplay="menu"
            loading={isLoading}
            responsiveLayout="scroll"
            emptyMessage="Không có đề xuất nào"
            scrollable
          >
            <Column
              field="vietnameseName"
              header={t('proposal.viewList.proposalName')}
              style={{ minWidth: '25rem' }}
              frozen
              alignFrozen="right"
            />
            <Column
              header={t('proposal.viewList.proposalType')}
              style={{ minWidth: '10rem' }}
              body={formatProposalType}
            />
            <Column
              field="projectType"
              header={t('proposal.viewList.projectType')}
              style={{ minWidth: '8rem', textAlign: 'center' }}
            />
            <Column
              header={t('proposal.viewList.researchField')}
              style={{ minWidth: '15rem' }}
              body={formatResearchField}
            />
            <Column
              header={t('proposal.viewList.owner')}
              headerStyle={{ justifyContent: 'center' }}
              style={{ minWidth: '12rem' }}
              field="owner.fullname"
            />
            <Column
              field="yearProposed"
              header={t('proposal.viewList.yearProposed')}
              style={{ minWidth: '9rem', textAlign: 'right' }}
            />
            <Column
              field="status"
              header={t('proposal.viewList.status')}
              style={{ width: '9rem', textAlign: 'center' }}
              body={formatStatus}
            />
            <Column
              header={t('proposal.viewList.actions')}
              body={formatActions}
              style={{ minWidth: '12rem', textAlign: 'center' }}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>

      <Confirm ref={dialogConfirmDeleteRef} refetch={refetch} />
      <ViewHistoryProposal
        data={projectHistory}
        visible={viewHistoryVisible}
        setVisible={setViewHistoryVisible}
      />
      <ViewRequests ref={dialogViewRequestsRef} refetchProjectProposals={refetch} />
    </div>
  );
}

export default ProposalViewList;
